module.exports = __webpack_public_path__ + "static/media/MHRP29N0004.8a52efe2.svg";